<template>
	<!-- 生成凭证 -->
	<div id='AddInvoiceImport'>
		<el-dialog
	          title="导入发票"
	          :visible.sync="isShow"
	          width="1100px"
	          :close-on-click-modal='false'
	          :close-on-press-escape="false"
	          class='AddInvoiceImportDialog'
	          >
	          <div v-loading='loading'>
	          	<div class='container clearfix'>
		          <div class='fl container_left'>
		          	  <div class="disabled" v-if='invoiceClassify!=2' @click.stop='handleClickModel("1")'></div>
			          	  <div class='title_s clearfix'>
			          	  		导入销项发票
			          	  		<span class='icon_text1'>销</span>
			          	  		<el-button size='mini' class='fr' v-if='fileList1.length!==0'
			          	  			@click='clearData("1")'
			          	  		>清空上传</el-button>
			          	  </div>
			          	  <div class='uploadList'>
			          	  	<el-upload
							  class="upload_style"
							  :class='fileList1.length!==0?"clearBorder":""'
							  drag
							  :on-change="OnChange"
							  :show-file-list='false'
							  :on-remove="OnRemove"
							  :before-upload='handleBeforeUpload'
							  :limit='handleLimit'
							  action="https://api.haozhang.vip/"
							  ref='upload1'
							  :auto-upload='false'
							  :disabled='invoiceClassify==1'
							   >
							  <div v-if='fileList1.length===0'>
							   	 <i class="el-icon-upload"></i>
								  <div class="el-upload__text" style="color: #666666">点击或将文件拖拽到这里上传</div>
								  <div class="el-upload__text" style="color: #999;font-size: 12px;margin-top: 5px;">只支持上传.xls/.xlsx文件，且不能超过5M</div>
							   </div>
							   <div v-else style='padding-top: 40px;'>
							   	  <img src="/static/img/excel.png" alt="">
							   	  <div style='margin-top: 20px;'>{{fileList1[0].name}}</div>
							   </div>

							  <div class="el-upload__tip" slot="tip"  style="text-align: left;color:#9B9B9B;font-size: 12px ">	
							  		<div >
							  			步骤1：从航信税控盘或百旺税控盘或全量发票或uk中导出Excel格式的销项发票明细；
							  		</div>
							  		<div style='margin-top: 15px;'>
							  			步骤2：导入销项发票：
							  		</div>
							  </div>
							</el-upload>
			          	  </div>
			          	  <div class='checkBox_s' >
			          	  		<el-checkbox style='color:#4A4A4A; ' v-model='isSkip1'>如果发票号码已存在，仅导入不存在的发票</el-checkbox>
			          	  </div>
			          </div> 
			          <div class='fr container_right'>
			          	<div class="disabled"  v-if='invoiceClassify!=1' @click.stop='handleClickModel("2")'></div>
			          	 <div class='title_s clearfix'>
			          	  	导入进项发票
			          	  	<span class='icon_text2'>进</span>
			          	  	<el-button size='mini' class='fr' v-if='fileList2.length!==0'
			          	  			@click='clearData("2")'
			          	  		>清空上传</el-button>
			          	  </div>
			          	  <div class='uploadList'>
			          	  	<el-upload
							  class="upload_style"
							  :class='fileList2.length!==0?"clearBorder":""'
							  drag
							  :auto-upload='false'
							  ref='upload2'
							  :on-change="OnChange"
							  :show-file-list='false'
							  :on-remove="OnRemove"
							  :before-upload='handleBeforeUpload'
							  :limit='handleLimit'
							  action="https://api.haozhang.vip/"
							  :disabled='invoiceClassify==2'
							   >

							   <div v-if='fileList2.length===0'>
							   	 <i class="el-icon-upload"></i>
								  <div class="el-upload__text" style="color: #666666">点击或将文件拖拽到这里上传</div>
								  <div class="el-upload__text" style="color: #999;font-size: 12px;margin-top: 5px;">只支持上传.xls/.xlsx文件，且不能超过5M</div>
							   </div>
							 <div v-else style='padding-top: 40px;'>
							   	  <img src="/static/img/excel.png" alt="">
							   	  <div style='margin-top: 20px;'>{{fileList2[0].name}}</div>
							   </div>


							  <div class="el-upload__tip" slot="tip"  style="text-align: left;color:#9B9B9B;font-size: 12px ">	
							  		<div >
										步骤1：从增值税发票选择确认平台（增值税发票认证平台）导出进项发票明细；
							  		</div>
							  		<div style='margin-top: 15px;'>
							  			步骤2：导入进项发票：
							  		</div>
							  </div>
							</el-upload>
			          	  </div>
			          	  <div class='checkBox_s'>
			          	  		<el-checkbox style='color:#4A4A4A; ' v-model='isSkip2'>如果发票号码已存在，仅导入不存在的发票</el-checkbox>
			          	  </div>
			          </div> 
		          </div>
		          <div style='margin-top: 50px;text-align: center;'>
		          	 <el-button style='background-color: #269D7B;color: #fff;width: 122px;' @click='handleInport_s'>确认导入</el-button>
		          </div>
	          </div>
	          
	    </el-dialog>
	   
	</div>
</template>
<script>
	export default {
		props:{
			AddInvoiceImportShow:Boolean,
			invoiceClassify:[String,Number]
		},
		components:{
			
		},
		data() {
			return {
				loading:false,
				isSkip1:false,
				isSkip2:false,
				handleLimit:1, //上传文件数	
				fileList1:[],   // 销项发票
				fileList2:[],
			}
		},
		created() {
			
		},
		computed:{
			
			// 显示弹窗
			isShow: {
				get () {
					return this.AddInvoiceImportShow;
				},
				set (val) {
					this.$emit('update:AddInvoiceImportShow', val);
				}
			},
		},
		methods:{
			handleClickModel(type) {
					return this.$message.warning('当前不可用！')
			},
			// 清空按钮
			clearData(t) {
				if(t==="1") {
					this.fileList1 = [];
					this.$refs.upload1.clearFiles();
				}else {
					this.$refs.upload2.clearFiles();
					this.fileList2 = [];
				}
			},
			// 上传之前验证
			handleBeforeUpload(file) {
				let testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
				const extension = testmsg === 'xls';
				const extension2 = testmsg === 'xlsx';
				const isLt5M = file.size / 1024 / 1024 < 5;
				if(!extension && !extension2) {
					this.$message({
						message: '上传文件只能是 xls、xlsx格式!',
						type: 'warning'
					});
					return false;
				}
				if(!isLt5M) {
					this.$message({
						message: '上传文件大小不能超过 5MB!',
						type: 'warning'
					});
					return false;
				}
			},
			// 传入文件监听
			 OnChange(file,fileList){
			 	if(this.invoiceClassify==2) {
			 		this.fileList1 = fileList;
			 	}else {
			 		this.fileList2 = fileList;
			 	}
			 },
			  // 移出操作
		      OnRemove(file,fileList){
		       if(this.invoiceClassify==2) {
			 		this.fileList1 = fileList;
			 	}else {
			 		this.fileList2 = fileList;
			 	}
		      },
		      // 导入文件
		      handleInport_s() {
		      	if((this.invoiceClassify==2&&!this.fileList1.length) || (this.invoiceClassify==1&&!this.fileList2.length)) {
					return this.$message.warning('请选择上传文件!')
				}
				this.loading = true;
		      	let params = new FormData();
				params.append('type',this.invoiceClassify);
				params.append('isSkip',this.invoiceClassify==2?this.isSkip1:this.isSkip2);
				params.append('multipartFile',this.invoiceClassify==2?this.fileList1[0].raw:this.fileList2[0].raw);
				params.append('cid',sessionStorage.getItem('cid'));
			    params.append('token',sessionStorage.getItem('token'));
			    const instance = this.$http.create({
			 		withCredentials: true
			 	})
		      	instance.post(this.$rootUrl + '/invoiceController/importFileInvoice' ,params).then(res=>{
		      		this.loading = false;
		      		let newDatas = [];
				    const h = this.$createElement;
				    let datas = (res.data.data&&res.data.data.list)?res.data.data.list:[];
						//3.通过循环data数组，调用h方法，将每项值传给h,h('标签名',样式,具体内容)
					    if(datas.length) {
					    	datas.forEach((i,index)=>{
					    		//4.将data数据push进newDatas数组中
					      		newDatas.push(h('p',{style: {color: 'red',fontSize: '14px'}},`${index+1}`+"、"+i));
					    	})
					    }
					if(res&&res.data.code==1){

					    newDatas.unshift(h('p',{style: {color: 'rgb(38, 157, 123)',fontSize: '14px',fontWeight:600}},"导入成功！"))
						this.$msgbox({
				          title: '导入结果',
				          message: h('div',null, newDatas),
				          showCancelButton: false,
				          showClose: false,
				          confirmButtonText: '确定',
				          cancelButtonText: '取消',
				        }).then(action => {
				         	this.$emit('successBack',true);
				         	this.fileList1 = [];
							this.fileList2 = [];
							this.$refs.upload1.clearFiles();
							this.$refs.upload2.clearFiles();
							this.isShow = false;
				        });

					}else {
						this.$emit('successBack',true);
						if(res.data.data&&res.data.data.list) {

							 newDatas.unshift(h('p',{style: {color: 'red',fontSize: '14px',fontWeight:600}},"导入失败！"))
							 this.$msgbox({
					          title: '导入结果',
					          message: h('div',null, newDatas),
					          showCancelButton: false,
					          showClose: false,
					          confirmButtonText: '确定',
					          cancelButtonText: '取消',
					        }).then(action => {
					         	
					        });
						}else {
							this.$message.error(res.data.msg);
						}
					}
				})
		      },
		}, 
		watch: {
			isShow(val) {
				if(!val) {
					this.fileList1 = [];
					this.fileList2 = [];
					this.$refs.upload1.clearFiles();
					this.$refs.upload2.clearFiles();
				}
			}
		}
	}
</script>
<style lang='less'>
		
	#AddInvoiceImport {
		.AddInvoiceImportDialog {
			.el-dialog__header {
				text-align: center;
				padding: 38px 0 32px;
				color:#333333;
				border-bottom: none;
				.el-dialog__title {
					font-size: 30px;
					font-weight: 500;
				}
			}
			.el-dialog__body {
				padding: 0px 30px 50px;
			}
			.container {
				/*左右公共样式*/
				.container_left,.container_right {
					position: relative;
					width: 500px;
					border:1px solid rgba(217,217,217,1);
					border-radius:4px;
					
					box-sizing: border-box;
					.title_s {
						color: #4A4A4A;
						font-size:18px;
						font-weight: 600;
						padding:30px;
					}
					.clearBorder {
						.el-upload-dragger {
							border:none;
						}
					}
					.disabled {
						width: 100%;
						height: 100%;
						position: absolute;
						background:rgba(0,0,0,.5);
						z-index: 199;
						cursor: pointer;
					}
					.icon_text1,.icon_text2 {
						display: inline-block;
						border-radius:2px;
						color: #fff;
						padding:0 2px;
						font-size: 14px;
						margin-left:5px;
					}
					.uploadList {
						
						text-align: center;
						.el-upload-dragger {
							width: 380px;
							height: 193px;
							background:rgba(251,251,251,1);
						}
						.el-upload__tip {
							width: 380px;
							margin:30px auto 0;

						}
					}
					.checkBox_s {
						width: 380px;
						margin:30px auto 30px;
					}

				}
				.container_left {
					.icon_text1 {
						background-color: #268AFF;
						
					}
				}
				.container_right {
					.icon_text2 {
						background-color: #20BD90;
					}
				}
			}
		}
		
	}
</style>


// WEBPACK FOOTER //
// src/components/dialog/AddInvoiceImport.vue